import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  thirdPartyTagPreview: {
    lineBreak: 'anywhere'
  }
})

export default useStyles
